module.exports = __webpack_public_path__ + "static/media/home-project-icon.331eb622.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-project-icon.svg
// module id = 1900
// module chunks = 0